import graphql__4443c437dd7a5e1ddc67 from "./__generated__/ProfileContribution_contribution.graphql.js";import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { useNavigateTo } from "../Routes/RoutesContext";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";
import Button from "../Buttons/Button";
import { useFormatDate, useFormatMessage } from "../Intl/Context";
import { defineMessages } from "react-intl";
import ReactableMeasures from "../ParticipativeModule/Visualizations/ReactableMeasures";

const ProfileContribution = props => {
  const contribution = useFragment(ProfileContribution_contribution, props.contribution);

  const { slug: participativeModuleSlug } = contribution.participativeModule;

  const { isDesktop, isNonDesktop } = useResponsiveFlag();

  const {
    title,
    slug: contributionSlug,
    publishedAt,
    publicationState,
    publicationStateName
  } = contribution;

  const t = useFormatMessage();
  const formatDate = useFormatDate();

  const isPublished = publicationState === "PUBLISHED";

  const dateMessageKey = isPublished ? "publishedAt" : "startedAt";
  const date = formatDate(publishedAt, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  });
  const dateLabel = t(intlMessages[dateMessageKey], { date });
  const anonymousContributionLabel = t(intlMessages.anonymousContributionLabel);

  const navigateTo = useNavigateTo();
  const navigateToContribution = useCallback(() => {
    navigateTo("contribution", { participativeModuleSlug, contributionSlug });
  }, [contributionSlug, navigateTo, participativeModuleSlug]);

  const handleClick = props.onClick || navigateToContribution;

  // Do not render the box if there's a missing contribution element
  if (!contribution) return null;

  const className = classNames([
    "box",
    "contribution",
    "padding-sm",
    "btn",
    "btn-block",
    "btn-unstyled",
    props.className,
    {
      "margin-top-sm": isDesktop,
      "margin-top-lg": isNonDesktop
    }
  ]);

  const publicationStateClassName = classNames(
    "float-right",
    "d-block",
    "badge-pill",
    "text-title-overview-sm",
    {
      "bg-danger": !isPublished,
      "text-white": !isPublished,
      "bg-success": isPublished
    }
  );

  return (
    <Button onClick={handleClick} className={className} data-show-contribution-button>
      <span className="d-block">
        <span className={publicationStateClassName}>{publicationStateName}</span>
        <span className="d-block title pointer mb-1">{title}</span>
        <span className="d-block text-muted text-title-overview-sm">{dateLabel}</span>

        {contribution.fromAnonymous && (
          <span className="badge badge-secondary text-title-overview-sm">
            {anonymousContributionLabel}
          </span>
        )}
      </span>

      <ReactableMeasures
        reactable={contribution}
        className="margin-top-xxs margin-bottom-none"
      />
    </Button>
  );
};

const ProfileContribution_contribution = graphql__4443c437dd7a5e1ddc67;

export default ProfileContribution;

const intlMessages = defineMessages({
  publishedAt: {
    id: "profile.contribution.publishedAt",
    defaultMessage: "Publiée le {date}"
  },
  startedAt: {
    id: "profile.contribution.startedAt",
    defaultMessage: "Démarrée le {date}"
  },
  anonymousContributionLabel: {
    id: "profile.contribution.anonymousContributionLabel",
    defaultMessage: "Contribution anonyme"
  }
});
